module.exports = __webpack_public_path__ + "static/brb-5d75c81a569c826c219851e921c58dbc.png";